import React from 'react'
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'

const PPErrorDisplaySpan:
    React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>
        & ErrorHandlingFormProps>
    = props => {
    const {
        messages, hint, hasError, clearErrorMessage, eventEmitter, eventKeys, clearError,
        ...rest
    } = props
    return <span {...rest}>{props.children}</span>
}
PPErrorDisplaySpan.displayName = 'PPErrorDisplaySpan'
export default createErrorHandlingForm(PPErrorDisplaySpan)
